export default {
  methods: {
    testFunction (msg) {
      return msg + '(works)';
    }
  }
};
